module.exports = __webpack_public_path__ + "static/media/nextArrowInactive.fea47eab.svg";